import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import { GiftAction, GiftDetail } from '../../../models/gifts/gift.model';
import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

// One gift with its audit trail, plus the G11.3 admin actions. Each action
// answers with the updated gift, so no refetch is needed afterwards.
const useGiftDetail = (giftId?: string) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [gift, setGift] = useState<GiftDetail | null>(null);

  useEffect(() => {
    if (!giftId) return;
    request(
      { url: `api/v1/admin/gifts/${giftId}`, method: 'get' },
      ({ data }: SuccessHttpResponse<GiftDetail>) => setGift(data),
      setLoading,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'Failed to load gift')
    );
    // eslint-disable-next-line
  }, [giftId]);

  const act = (action: GiftAction, note: string, onDone?: () => void) => {
    if (!giftId) return;
    request(
      {
        url: `api/v1/admin/gifts/${giftId}/${action}`,
        method: 'post',
        data: note.trim() ? { note: note.trim() } : undefined,
      },
      ({ data }: SuccessHttpResponse<GiftDetail>) => {
        setGift(data);
        toast.success('Done');
        onDone?.();
      },
      setSaving,
      (err: AxiosError<ErrorHttpResponse>) =>
        toast.error(err?.response?.data?.message ?? 'That action failed')
    );
  };

  return { gift, loading, saving, act };
};

export default useGiftDetail;
